import styled from 'styled-components'
export const Container = styled.div`
    border-radius: 8px;
    padding: 2rem;
    height: 30rem;
    width: 100%;
`
export const Card = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
`
export const Title = styled.div`
    font-size: 1rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
`
export const ContainerCard = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    img {
        margin-bottom: 1rem;
    }
`
export const Exam = styled.div``
export const ExamName = styled.div`
    font-weight: 700;
    font-size: 1rem;
`
export const ExamList = styled.div`
    text-align: center;
`
export const ExamPrice = styled.div`
    font-size: 0.875rem;
    font-weight: 400;
    margin-bottom: 2rem;
    span {
        font-weight: 700;
        line-height: 1rem;
    }
`
